









































import { Component, Prop, Vue } from "vue-property-decorator";
//import Vue from 'vue'
//import VueYoutube from 'vue-youtube'

//Vue.use(VueYoutube)

interface Album {
  //player: string;
  title: string;
  comment: string;
  url: string;
  items: Array<string>;
  //comment: Comment;
}
interface Item {
  id: string;
  title: string;
  type: string;
}
//interface Comment {
//  title: string;
//  items: Array<string>
//}

@Component
export default class PhotoWorld extends Vue {

  @Prop()
  private msg!: string;
  
  colors = [{id: '/photo/mitsuta', title: '三津田高校'},
            {id: '/photo/kikaika', title: '機械科'},
           ];
      
  albumIndex = 0;
  albumTitle = '';
  albumComment = '';
  photoIndex = 0;
  imageSrc = '';
    
  album_1:Album = {
    title: '呉三津田高校同窓会（20170401）の思い出',
    comment: '浅草→浜離宮',
    url: 'http://www.hiroict.com/files/mimamori/photo/呉三津田高校同窓会20170401/',
    items: ['IMG_20170401_112041.jpg',
           'IMG_20170401_112054.jpg',
           'IMG_20170401_112229.jpg',
           'IMG_20170401_112309.jpg',
           'IMG_20170401_112321.jpg',
           'IMG_20170401_114556.jpg',
           'IMG_20170401_115726.jpg',
           'IMG_20170401_115732.jpg',
           'IMG_20170401_115736.jpg',
           'IMG_20170401_120007.jpg',
           'IMG_20170401_121445.jpg',
           'IMG_20170401_121449.jpg',
           'IMG_20170401_123438.jpg',
           'IMG_20170401_123442.jpg',
           'IMG_20170401_130232.jpg',
           'IMG_20170401_131116.jpg',
           'IMG_20170401_131117.jpg',
           'IMG_20170401_131122.jpg',
           'IMG_20170401_131133.jpg',
           'IMG_20170401_135916.jpg',
           'IMG_20170401_135919.jpg',
           'IMG_20170401_140113.jpg',
           'IMG_20170401_140932.jpg',
           'IMG_20170401_140934.jpg',
           'IMG_20170401_141025.jpg',
           'IMG_20170401_141037.jpg',
           'IMG_20170401_141418.jpg',
           'IMG_20170401_141503.jpg',
          ],
    };
    photoIndex_2 = 0;
    imageSrc_2 = '';
    album_2:Album = {
        title: '呉三津田高校同窓会（20191213）の思い出',
        comment: '東京サミット 18:00～20:00',
        url: 'http://www.hiroict.com/files/mimamori/photo/呉三津田高校同窓会20191213/',
        items: [
            'IMG_20191213_205539.jpg',
            'IMG_20191213_205541.jpg',
            'IMG_20191213_205543.jpg',
            'IMG_20191213_205545.jpg',
            'IMG_20191213_205548.jpg',
            'IMG_20191213_205551.jpg',
            'IMG_20191213_205555.jpg',
            'IMG_20191213_205605.jpg',
            'IMG_20191213_205607.jpg',
            'IMG_20191213_205610.jpg',
            'IMG_20191213_205613.jpg',
            'IMG_20191213_205615.jpg',
            'IMG_20191213_205616.jpg',
            'IMG_20191213_205745.jpg',
            'IMG_20191213_205751.jpg',
            'IMG_20191213_205757.jpg',
            'IMG_20191213_205859.jpg',
            'IMG_20191213_205903.jpg',
            'IMG_20191213_205909.jpg',
            'IMG_20191213_210026.jpg',
            'IMG_20191213_210028.jpg',
            'IMG_20191213_210031.jpg',
            'IMG_20191213_210039.jpg',
            'IMG_20191213_210041.jpg',
            'IMG_20191213_210048.jpg',
            'IMG_20191213_210051.jpg',
            'IMG_20191213_210053.jpg',
            'IMG_20191213_210057.jpg',
            'IMG_20191213_210150.jpg',
            'IMG_20191213_210151.jpg',
            ],
       };
    albums: Array<Album>;

  /** ライフサイクルフック */
  public created() {
    this.albums = [this.album_2, this.album_1];
    this.firstImage();
  }
  public selectAlbum(index:number) {
      this.albumIndex = index
      this.firstImage()
  }
  public previousImage() {
      this.photoIndex --
      if (this.photoIndex < 0) {
        this.photoIndex = this.albums[this.albumIndex].items.length - 1
      }
      this.imageSrc = this.albums[this.albumIndex].url + this.albums[this.albumIndex].items[this.photoIndex]
      this.albumTitle = this.albums[this.albumIndex].title
      this.albumComment = this.albums[this.albumIndex].comment
      window.console.log("previousImage() 1.this.imageSrc: " + this.imageSrc);
  }
  public firstImage() {
      this.photoIndex = 0
      this.imageSrc = this.albums[this.albumIndex].url + this.albums[this.albumIndex].items[this.photoIndex]
      this.albumTitle = this.albums[this.albumIndex].title
      this.albumComment = this.albums[this.albumIndex].comment
      window.console.log("firstImage() 1.this.imageSrc: " + this.imageSrc);
    }
  public nextImage() {
      window.console.log("nextImage() 1.this.imageSrc: " + this.imageSrc);
      this.photoIndex ++
      if (this.photoIndex > this.albums[this.albumIndex].items.length - 1) {
        this.photoIndex = 0
      }
      this.imageSrc = this.albums[this.albumIndex].url + this.albums[this.albumIndex].items[this.photoIndex]
      this.albumTitle = this.albums[this.albumIndex].title
      this.albumComment = this.albums[this.albumIndex].comment
      window.console.log("nextImage() 2.this.imageSrc: " + this.imageSrc);
    }


  /*
  public created(){
    this.danceAlbums = [this.dance_album_1, this.dance_album_2];
    this.karaokeAlbums = [this.karaoke_album_1, this.karaoke_album_2, this.karaoke_album_3, this.karaoke_album_4, this.karaoke_album_5];
    this.categories = [this.danceAlbums, this.karaokeAlbums];
    this.firstAudio();
  }
  public onEnded() {
      window.console.log("onEnded() 1.audioIndex_1: " + this.audioIndex);
      //window.interactiveCanvas.sendTextQuery('もう一度');
      this.nextAudio()
      //this.vplay()
  }
  public vplay() {
     window.console.log("vplay()");
     const v = document.getElementById("audio1");
     // todo
     //v.play();
  }
  public selectCategory(index:number) {
     window.console.log("selectCategory() 1.index: " + index);
     this.categoryIndex = index;
     this.selectAlbum(0)
  }

  public selectAlbum(index:number) {
     window.console.log("selectAlbum() 1.index: " + index);
     this.albumIndex = index;
     this.firstAudio()
  }
  public previousAudio() {
     window.console.log("previousAudio() 1.this.albumIndex: " + this.albumIndex);
     this.audioIndex --
     if (this.audioIndex < 0) {
       this.audioIndex = this.categories[this.categoryIndex][this.albumIndex].items.length - 1
     }
     this.audioSrc = this.categories[this.categoryIndex][this.albumIndex].url + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title + '.' + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].type
     this.audioTitle = this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title
  }
  public firstAudio() {
    window.console.log("firstAudio() 1.this.albumIndex: " + this.albumIndex);
    this.audioIndex = 0
    this.audioSrc = this.categories[this.categoryIndex][this.albumIndex].url + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title + '.' + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].type
    this.audioTitle = this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title
  }
  public nextAudio() {
    window.console.log("nextAudio() 1.this.albumIndex: " + this.albumIndex);
    this.audioIndex ++
    if (this.audioIndex > this.categories[this.categoryIndex][this.albumIndex].items.length - 1) {
      this.audioIndex = 0
    }
    this.audioSrc = this.categories[this.categoryIndex][this.albumIndex].url + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title + '.' + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].type
    this.audioTitle = this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title
  }
  public selectAudio(index:number) {
    window.console.log("selectAudio() 1.index: " + index);
    this.audioIndex = index
    this.audioSrc = this.categories[this.categoryIndex][this.albumIndex].url + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title + '.' + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].type
    this.audioTitle = this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title
  }
  */
}

/*
export default {
  name: 'MusicWorld',
  props: {
    msg: String
  },
  data() {
    return {
      musicCategories: [{id: '1', title: 'ダンス音楽'},
                         {id: '2', title: 'カラオケ音楽'},
                        ],
      albumIndex: 0,
      audioIndex: 0,
      audioTitle : '01 いきいきストレッチング',
      audioSrc : 'http://www.hiroict.com/files/talkai/トークA愛/ダンス音楽/トークA/火曜日スポーツセンター用/01 いい日旅立ち.mp3',

      dance_album_1 : {player: 'トークA',
                 title : '火曜日スポーツセンター用',
                 url : 'http://www.hiroict.com/files/talkai/トークA愛/ダンス音楽/トークA/火曜日スポーツセンター用/',
                 items: [{id:1, title:'01 いきいきストレッチング', type:'mp3'},
                         {id:2, title:'02 歩く（SUPER MAN）', type:'mp3'},
                         {id:3, title:'03 歩く（ACADOO）', type:'mp3'},
                         {id:4, title:'04 ワルツ（魅惑のワルツ）', type:'mp3'},
                         {id:5, title:'05 タンゴ（オレ・グアッパ）', type:'mp3'},
                         {id:6, title:'06 フオックス（貴方なしでは）', type:'mp3'},
                         {id:7, title:'07 クイック（ダンス ダーリン ダンス）', type:'mp3'},
                         {id:8, title:'08 ルンバ（枯葉）', type:'mp3'},
                         {id:9, title:'09 チャチャチャ（セレソローサ）', type:'mp3'},
                         {id:10, title:'10 サンバ（ラクカラチャ）', type:'mp3'},
                         {id:11, title:'11 ジャイブ（串本節）', type:'mp3'},
                         {id:12, title:'12 リトニック（THE BIRDIE SONG）', type:'mp3'}
                         ],
                },
      dance_album_2 : {player: 'トークA',
                 title : 'party night',
                 url : 'http://www.hiroict.com/files/talkai/トークA愛/ダンス音楽/トークA/party night/',
                 items: [{id:1, title: '01 ラストダンスは私に', type: 'm4a' },
                         {id:2, title: '02 アディオス・マルキータ・リンダ', type: 'm4a' },
                         {id:3, title: '03 枯葉', type: 'm4a' },
                         {id:4, title: '04 夜のストレンジャー', type: 'm4a' },
                         {id:5, title: '05 グアヒーラ', type: 'm4a' },
                         {id:6, title: '06 グリーンスリーブス', type: 'm4a' },
                         {id:7, title: '07 月下の蘭', type: 'm4a' },
                         {id:8, title: '08 この世の果てまで', type: 'm4a' },
                         {id:9, title: '09 ジェシカ', type: 'm4a' },
                         {id:10, title: '10 スタンブリング', type: 'm4a' },
                         {id:11, title: '11 短くも美しく燃え', type: 'm4a' }
                        ],
                },
      
      danceAlbums: Array<Album>;
      
      karaoke_album_1 : {
        player : 'ZARD',
        title : '揺れる想い',
        url : 'http://www.hiroict.com/files/talkai/トークA愛/カラオケ/ZARD/揺れる想い/',
        items: [{id:'1', title:'01 揺れる想い', type:'mp3'},
                {id:'2', title:'02 Season', type:'mp3'},
                {id:'3', title:'03 君がいない (B-version)', type:'mp3'},
                {id:'4', title:'04 In my arms tonight', type:'mp3'},
                {id:'5', title:'05 あなたを好きだけど', type:'mp3'},
                {id:'6', title:'06 負けないで', type:'mp3'},
                {id:'7', title:'07 Listen to me', type:'mp3'},
                {id:'8', title:'08 You and me (and...)', type:'mp3'},
                {id:'9', title:'09 I want you', type:'mp3'},
                {id:'10', title:'10 二人の夏', type:'mp3'}],
      },
      karaoke_album_2 : {player: '倍賞千恵子',
                 title : 'うたがたり ～ 叙情歌ベストコレクション1（Disc 1）',
                 url : 'http://www.hiroict.com/files/talkai/トークA愛/カラオケ/倍賞千恵子/うたがたり ～ 叙情歌ベストコレクション1（Disc 1）/',
                 items: [{id:'1', title:'01 いい日旅立ち', type:'mp3'},
                         {id:'2', title:'02 空に星があるように', type:'mp3'},
                         {id:'3', title:'03 見上げてごらん夜の星を', type:'mp3'},
                         {id:'4', title:'04 星屑の町', type:'mp3'},
                         {id:'5', title:'05 港が見える丘', type:'mp3'},
                         {id:'6', title:'06 胸の振子', type:'mp3'},   
                         {id:'7', title:'07 リンゴの唄', type:'mp3'},
                         {id:'8', title:'08 蘇州夜曲', type:'mp3'},
                         {id:'9', title:'09 月の沙漠', type:'mp3'},
                         {id:'10', title:'10 春の唄', type:'mp3'},
                         {id:'11', title:'11 早春賦', type:'mp3'},
                         {id :'12', title:'12 夏は来ぬ', type:'mp3'},
                         {id:'13', title:'13 みかんの花咲く丘', type:'mp3'},
                        ],  
                },
      karaoke_album_3 : {player: '倍賞千恵子',
                 title: 'うたがたり ～ 叙情歌ベストコレクション1（Disc 2）',
                 url : 'http://www.hiroict.com/files/talkai/トークA愛/カラオケ/倍賞千恵子/うたがたり ～ 叙情歌ベストコレクション1（Disc 2）/',
                 items: [{id:'1', title:'01 朧月夜', type:'mp3'},
                         {id:'2', title:'02 鯉のぼり', type:'mp3'},
                         {id:'3', title:'03 われは海の子', type:'mp3'},
                         {id:'4', title:'04 海', type:'mp3'},
                         {id:'5', title:'05 冬景色', type:'mp3'},
                         {id:'6', title:'06 春が来た', type:'mp3'},
                         {id:'7', title:'07 春の小川', type:'mp3'},
                         {id:'8', title:'08 村の鍛冶屋', type:'mp3'},
                         {id:'9', title:'09 汽車', type:'mp3'},
                        ],
                },
      karaoke_album_4 : {
        player : '東洋大学',
        title : '実験',
        url : 'http://www.hiroict.com/files/talkai/トークA愛/カラオケ/東洋大学/実験/',
        items: [{id:'1', title:'01 津軽海峡冬景色', type:'mp3'},
                {id:'2', title:'02 上を向いて歩こう', type:'mp3'},
                {id:'3', title:'03 山', type:'mp3'},
                {id:'4', title:'04 レモン', type:'mp3'},
                {id:'5', title:'05 マリーゴールド', type:'mp3'}]
        },

      karaoke_album_5 : {
        player: 'かぐや姫',
        title: '全曲集',
        url : 'http://www.hiroict.com/files/talkai/トークA愛/カラオケ/かぐや姫/全曲集/',
        items: [{id:'1', title:'01_神田川', type:'m4a'},
                {id:'2', title:'02_僕の胸でおやすみ', type:'m4a'},
                {id:'3', title:'03_赤ちょうちん', type:'m4a'},
                {id:'4', title:'04_妹', type:'m4a'},
                {id:'5', title:'05_僕は何をやってもだめな男です', type:'m4a'},
                {id:'6', title:'06_加茂の流れに', type:'m4a'},
                {id:'7', title:'07_雨が空から降れば', type:'m4a'},
                {id:'8', title:'08_あの人の手紙', type:'m4a'},
                {id:'9', title:'09_この秋に', type:'m4a'},
                {id:'10', title:'10_今はちがう季節', type:'m4a'},
                {id:'11', title:'11_22才の別れ', type:'m4a'},
                {id:'12', title:'12_なごり雪', type:'m4a'},
                {id:'13', title:'13_置手紙', type:'m4a'},
                {id:'14', title:'14_アビーロードの街', type:'m4a'},
                {id:'15', title:'15_けれど生きている', type:'m4a'},
                {id:'16', title:'16_あてもないけど', type:'m4a'},
                {id:'17', title:'17_ペテン師', type:'m4a'},
               ],
        },

      karaokeAlbums: Array<Album>;
      categoryIndex: 0,
      
      categories: [],
    }
  },
  created () {
    this.danceAlbums = [this.dance_album_1, this.dance_album_2]
    this.karaokeAlbums = [this.karaoke_album_1, this.karaoke_album_2, this.karaoke_album_3, this.karaoke_album_4, this.karaoke_album_5]
    this.categories = [this.danceAlbums, this.karaokeAlbums]
    this.firstAudio()
  },
  methods: {
    onEnded: function () {
      window.console.log("onEnded() 1.audioIndex_1: " + this.audioIndex_1);
      //window.interactiveCanvas.sendTextQuery('もう一度');
      this.nextAudio()
      //this.vplay()
    },
    vplay() {
       window.console.log("vplay()");
       var v = document.getElementById("audio1");
       v.play();
    },

    selectCategory(index) {
      window.console.log("selectCategory() 1.index: " + index);
      this.categoryIndex = index;
      this.selectAlbum(0)
    },

    selectAlbum(index) {
      window.console.log("selectAlbum() 1.index: " + index);
      this.albumIndex = index;
      this.firstAudio()
    },
    previousAudio() {
      window.console.log("previousAudio() 1.this.albumIndex: " + this.albumIndex);
      this.audioIndex --
      if (this.audioIndex < 0) {
        this.audioIndex = this.categories[this.categoryIndex][this.albumIndex].items.length - 1
      }
      this.audioSrc = this.categories[this.categoryIndex][this.albumIndex].url + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title + '.' + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].type
      this.audioTitle = this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title
    },
    firstAudio() {
      window.console.log("firstAudio() 1.this.albumIndex: " + this.albumIndex);
      this.audioIndex = 0
      this.audioSrc = this.categories[this.categoryIndex][this.albumIndex].url + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title + '.' + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].type
      this.audioTitle = this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title
    },
    nextAudio() {
      window.console.log("nextAudio() 1.this.albumIndex: " + this.albumIndex);
      this.audioIndex ++
      if (this.audioIndex > this.categories[this.categoryIndex][this.albumIndex].items.length - 1) {
        this.audioIndex = 0
      }
      this.audioSrc = this.categories[this.categoryIndex][this.albumIndex].url + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title + '.' + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].type
      this.audioTitle = this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title
    },
    selectAudio(index) {
      window.console.log("selectAudio() 1.index: " + index);
      this.audioIndex = index
      this.audioSrc = this.categories[this.categoryIndex][this.albumIndex].url + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title + '.' + this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].type
      this.audioTitle = this.categories[this.categoryIndex][this.albumIndex].items[this.audioIndex].title
    },


  },
*/


